import React, { useState, useEffect, useMemo, useCallback } from "react";
import CommonCard from "../common/commonCard";
import Header from "../common/header";
import Sidebar from "../common/navBar";
import { Container, Row, Col, Button } from "react-bootstrap";
import FormCard from "../common/formCard";
import RTE from "../common/RTE";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CheckBox from "../common/customCheckBox";
import Footer from "../common/footer";
import MessagePopUp from "../common/messagePopUp";
import { GetUsersSelectService } from "../../Services/userService";
import { getFileInformation } from "../../utils/base64Conver";
import { GetComapanyService, PatchCompanyService } from "../../Services/companyService";
import Spinner from 'react-bootstrap/Spinner';
import CustomTabs, { CustomTab } from "../common/customTabs";
import CustomTable from "../common/table";
import PopUpWorkPlacesManage from "../specific/popUpWorkPlacesManage";
import { GetWorkPlacesFromCompanyService, PatchWorkPlaceService, PostWorkPlaceService } from "../../Services/workPlaceService";
import { initReactI18next, useTranslation } from 'react-i18next';
import { DisabledTextCompanyService } from "../../Services/textCompanyService";
import CertificationsCard from "../specific/certificationsCard";
import { FaCircleQuestion, FaDownload, FaList, FaRectangleList } from "react-icons/fa6";
import { FaFileSignature } from "react-icons/fa";
import DownloadCertificationsPopUp from "../specific/downloadCertificationsPopUp";
import { GetSignFilesService } from "../../Services/signFileService";
import PopUpSignFilesManage from "../specific/popUpSignFilesManage";
import { BiSolidCategoryAlt } from "react-icons/bi";
import CustomizationCards from "../specific/customizationCard";
import { GetIncidentCategoriesNotDefaultService } from "../../Services/incidentCategoryService";
import { GetCustomQuestionsService } from "../../Services/customQuestionsService";
import { generateQRBase64 } from "../../utils/downloadQr";
import { GetCategoryResponsiblesFromCompanyService, PatchCategoryResponsiblesService, PostCategoryResponsiblesService } from "../../Services/categoryResponsiblesService";
import { GetIncidentCategoriesService } from "../../Services/incidentCategoryService";
import PopUpCategoryResponsiblesManage from "../specific/popUpCategoryResponsiblesManage";


const EditCompany = () => {
  const [t] = useTranslation("companies")
  const [changeData, setChangeData] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [file, setFile] = useState(null);
  const [password, setPassword] = useState(null);
  const [showDownloadResponsibles, setShowDownloadResponsibles] = useState(false);
  const [showCompanyCategoriesCreate, setShowCompanyCategoriesCreate] = useState(false);
  const [createdNewWorkplace, setCreatedNewWorkplace] = useState(false);
  const [showPopupError, setShowPopupError] = useState(false);
  const [showModalError, setShowModalError] = useState(false);
  const [showPopupContinue, setShowPopupContinue] = useState(false);
  const [showModalContinue, setShowModalContinue] = useState(false);
  const [showPopupWorkPlacesManage, setShowPopupWorkPlacesManage] = useState(false);
  const [showPopupCategoryResponsiblesManage, setShowPopupCategoryResponsiblesManage] = useState(false);
  const [showPopupSignFilesManage, setShowPopupSignFilesManage] = useState(false);
  const [showPopupErrorWorkPlaces, setShowPopupErrorWorkPlaces] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [workplaceData, setWorkplaceData] = useState(null);
  const [workplacesData, setWorkplacesData] = useState(null);
  const [enabledWorkplaces, setEnabledWorkplaces] = useState(null);
  const [categoryResponsiblesData, setCategoryResponsiblesData] = useState(null);
  const [categoryResponsibleData, setCategoryResponsibleData] = useState(null);
  const [signFilesData, setSignFilesData] = useState(null);
  const [categoriesData, setCategoriesData] = useState(null);
  const [allCategoriesData, setAllCategoriesData] = useState(null);
  const [questionsData, setQuestionsData] = useState(null);
  const [companyData, setCompanyData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [spanishText, setSpanishText] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const location = useLocation();
  // const companyData = location.state?.data;
  const [responsibleOptions, setResponsibleOptions] = useState([]);
  const [responsibleOptionsCategoryResponsibleFull, setResponsibleOptionsCategoryResponsibleFull] = useState([]);
  const [responsibleOptionsFull, setResponsibleOptionsFull] = useState([]);
  const [responsibleManagementOptions, setResponsibleManagementOptions] = useState([]);
  const [responsibleFunctionsOptions, setResponsibleFunctionsOptions] =
    useState([]);
  const [categoryResponsiblesCategories, setCategoryResponsiblesCategories] = useState([]);
  const [categoryResponsiblesWorkplaces, setCategoryResponsiblesWorkplaces] = useState([]);
  const [categoryResponsiblesResponsibleNames, setCategoryResponsiblesResponsibleNames] = useState([]);
  const [companyCategoriesKey, setCompanyCategoriesKey] = useState(1);

  const [changedFields, setChangedFields] = useState({});

  const [initialFormData1, setInitialFormData1] = useState({});

  const [qrBase64, setQrBase64] = useState(null);

  useEffect(() => {
    if (isLoaded) {
      const img = dataURItoFile(
        `data:${companyData.imageMimeType};base64,${companyData.imageData}`
      );
      setInitialFormData1({
        nifCif: companyData.nifCif,
        name: companyData.name,
        responsibleId: companyData.responsibleId,
        functionResponsibleId: companyData.functionResponsibleId,
        responsibleManagementId: null,
        text: companyData.textCompanies.find(item => item.language === 'es'),
        textCA: companyData.textCompanies.find(item => item.language === 'ca'),
        textEU: companyData.textCompanies.find(item => item.language === 'eu'),
        textEN: companyData.textCompanies.find(item => item.language === 'en'),
        textIT: companyData.textCompanies.find(item => item.language === 'it'),
        workplaces: companyData.workplaces,
        image: img,
      });
      generateQR(companyData.publicLink)
    }
  }, [isLoaded]);

  async function generateQR(link) {
    const qrBase64 = await generateQRBase64(link);
    setQrBase64(qrBase64)
  }


  const enabled = [
    `${t("workPlacesTableFilters.enabled")}`,
    `${t("workPlacesTableFilters.disabled")}`
  ];

  const categoryResponsiblesColumnHeaders = useMemo(() => {
    return [
      t("categoryResponsibles.categoryName"),
      workplacesData?.length > 0 ? t("categoryResponsibles.workplace") : '',
      t("categoryResponsibles.responsibleFullNameNIF"),
    ];
  }, [workplacesData, t]);

  const columnHeaders = useMemo(() => [
    t("workPlaces.name"),
    t("workPlaces.responsible"),
    t("workPlaces.enabled")
  ], [t]);

  const signFilesColumnHeaders = useMemo(() => [
    t("signFiles.type"),
    t("signFiles.fileName"),
    t("signFiles.createdAt")
  ], [t]);

  const fieldsToShow = ['workplaceName', 'responsibleWorkPlaceFullNameNIF', 'workplaceEnabled'];
  const signFilesFieldsToShow = ['type', 'fileName', 'createdAt'];
  const categoryResponsiblesFieldsToShow = workplacesData?.length > 0
    ? ['categoryName', 'workplaceName', 'responsibleFullNameNIF']
    : ['categoryName', '', 'responsibleFullNameNIF'];


  const optionArrays = [[], [], enabled]
  const categoryResponsiblesOptionArrays = [categoryResponsiblesCategories, workplacesData?.length > 0 ? categoryResponsiblesWorkplaces : [], categoryResponsiblesResponsibleNames];


  const navigate = useNavigate();
  const { id } = useParams();

  const [formData1, setFormData1] = useState([]);

  const [isForm1Valid, setIsForm1Valid] = useState(false);

  const [formData1Changed, setFormData1Changed] = useState(false);

  function dataURItoFile(img) {
    const byteString = atob(img.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([ab], { type: "image/png" }); // Cambia 'image/png' según el tipo de archivo que sea
    return new File([blob], "image.png");
  }

  useEffect(() => {

    const getCompany = async () => {
      const companyData = await GetComapanyService(id);
      setCompanyData(companyData);
      setIsLoaded(true);
    }
    getCompany();
  }, [changeData])

  useEffect(() => {
    if (isLoaded && spanishText) {


      const dataChanged1 =
        JSON.stringify(initialFormData1) !== JSON.stringify(formData1) ||
        !filesAreEqual(initialFormData1.image, formData1.image);
      setFormData1Changed(dataChanged1);
      const addTabsAsync = async () => {
        for (const key in initialFormData1) {

          if (key.startsWith('text') && initialFormData1[key] && !langTabs.some(tab => tab.language === initialFormData1[key].language)
            && initialFormData1[key].enabled) {
            await addTab(initialFormData1[key].language);
          }
        }
      };
      addTabsAsync();
    }
  }, [formData1, initialFormData1, changeData]);


  function filesAreEqual(file1, file2) {
    return (
      file1.size === file2.size &&
      file1.name === file2.name &&
      file1.type === file2.type
    );
  }

  useEffect(() => {
    if (isLoaded) {
      setFormData1(initialFormData1);
    }
  }, [initialFormData1, isLoaded]);

  function rteAreEqual(rte1, rte2) {
    if (rte1 && rte2) {
      return (
        rte1.text === rte2.text
      );
    } else {
      return false
    }
  }

  useEffect(() => {
    const fetchDataResponsibleOptions = async () => {
      try {
        if (isLoaded) {
          const result = await GetUsersSelectService();
          const formattedData = result
            .filter((data) => data.user !== formData1.functionResponsibleId && data.user !== formData1.responsibleId)
            .map((data) => ({
              label: `${data.name} ${data.surname} (${data.nif})`,
              value: data.user,
            }));

          const formattedDataFull = result
            .map((data) => ({
              label: `${data.name} ${data.surname} (${data.nif})`,
              value: data.user,
            }));

          const formattedDataFunctions = result
            .filter((data) => data.user !== formData1.responsibleId)
            .map((data) => ({
              label: `${data.name} ${data.surname} (${data.nif})`,
              value: data.user,
            }));

          const formattedDataManagement = result
            .filter((data) => data.user !== formData1.responsibleManagementId)
            .map((data) => ({
              label: `${data.name} ${data.surname} (${data.nif})`,
              value: data.user,
            }));



          // Añadimos un objeto al inicio del array
          if (companyData.functionResponsibleId || formData1.functionResponsibleId) {
            formattedDataFunctions.unshift({
              label: "---",
              value: "NULL",
            });
          }



          const formattedDataFullWithoutNull = formattedDataFull.filter(option => option.value !== "NULL");

          formattedDataFull.unshift({
            label: "---",
            value: "NULL",
          });


          setResponsibleOptions(formattedData);
          setResponsibleOptionsCategoryResponsibleFull(formattedDataFullWithoutNull)
          setResponsibleOptionsFull(formattedDataFull);
          setResponsibleFunctionsOptions(formattedDataFunctions);
          setResponsibleManagementOptions(formattedDataManagement)
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchDataResponsibleOptions();
  }, [formData1, formData1Changed]);

  useEffect(() => {
    if (isLoaded) {
      const { nifCif, name, responsible } = formData1;
      const allFieldsFilled = [nifCif, name, responsible].every(
        (field) => field !== ""
      );

      const isValidCIF = (cif) => {
        const regex = /^[A-Za-z][0-9]{7}[A-Za-z0-9]$/;
        return regex.test(cif);
      };

      const isValidNIF = (nif) => {
        const nifRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;
        const nieRegex = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;
        const letters = "TRWAGMYFPDXBNJZSQVHLCKE";
        let number, letter;

        if (nifRegex.test(nif)) {
          number = parseInt(nif.slice(0, 8), 10);
          letter = nif.slice(8).toUpperCase();
        } else if (nieRegex.test(nif)) {
          const initialLetterMappings = { X: "0", Y: "1", Z: "2" };
          const initialLetter = nif[0].toUpperCase();
          number = parseInt(
            initialLetterMappings[initialLetter] + nif.slice(1, 8),
            10
          );
          letter = nif.slice(8).toUpperCase();
        } else {
          return false; // No es ni NIF ni NIE válido
        }

        return letters[number % 23] === letter;
      };

      const isValidNIFCIF = (string) => isValidCIF(string) || isValidNIF(string);

      // Update this boolean based on your requirements
      const isValid = allFieldsFilled && isValidNIFCIF(nifCif);

      setIsForm1Valid(isValid);
    }
  }, [formData1]);

  const [fieldErrors, setFieldErrors] = useState({
    text: null,
    image: null,
    name: false,
    nameMessage: null,
  });

  useEffect(() => {
    const allFieldsValid = Object.values(fieldErrors).every((error) => !error);
    setIsForm1Valid(allFieldsValid);
  }, [fieldErrors]);

  const validateAllFields = () => {
    const { nifCif, name, responsible, responsibleManagement, text, image } = formData1;

    const isNameValid = validateField("name", name);

    const isNifCifValid = validateField("nifCif", nifCif);

    const isResponsibleValid = validateField("responsible", responsible);

    const isImageValid = validateField("image", image);

    return isNameValid && isNifCifValid && isResponsibleValid && isImageValid;
  };

  const validateField = async (field, value) => {
    let isError = false;
    let errorMessage = null;

    switch (field) {
      case "nifCif":
        isError = !isValidNIFCIF(value);
        errorMessage = isError
          ? `${t("companyForm.nifError")}`
          : null;
        break;
      case "name":
        isError = value === "";
        errorMessage = isError
          ? `${t("companyForm.nameError")}`
          : null;
        break;
      case "responsible":
        isError = value === "";
        errorMessage = isError
          ? `${t("companyForm.responsibleError")}`
          : null;
        break;

      case "text":
        isError = true;
        errorMessage = isError
          ? `${t("companyForm.textError")}`
          : null;
        break;

      case "image":
        const url = URL.createObjectURL(value);

        let img;
        let fileSizeKB;

        if (value) {
          img = new Image();

          // Esperar hasta que la imagen se haya cargado
          await new Promise((resolve) => {
            img.onload = resolve;
            img.src = url;
          });

          fileSizeKB = Math.round((value.size / 1024) * 100) / 100;
        }
        if (
          (img.width > 1000 || img.width < 700) ||
          (img.height > 350 || img.height < 150)
        ) {
          isError = true;
          errorMessage = isError
            ? `${t("companyForm.imageSizeError")}`
            : null;
        } else if (fileSizeKB > 2000) {
          isError = true;
          errorMessage = isError
            ? `${t("companyForm.imageWeightError")}`
            : null;
        }
        break;

      default:
        break;
    }
    setFieldErrors((prevFieldErrors) => {
      const newErrors = { ...prevFieldErrors, [field]: isError };
      newErrors[`${field}Message`] = errorMessage;
      return newErrors;
    });
    return !isError;
  };

  const handleInputChange = (field, value, setFormData) => {

    if (initialFormData1[field] !== undefined) {

      setFormData((prevFormData) => {
        const updatedFormData = { ...prevFormData, [field]: value };

        validateField(field, value); // Validar el campo cuando se actualiza

        // Rastrear los campos cambiados respecto al formulario inicial
        setChangedFields((prevChangedFields) => {
          let newChangedFields = { ...prevChangedFields };

          // Lógica especial para comparar archivos
          if (field === "image") {
            if (!filesAreEqual(initialFormData1[field], value)) {
              newChangedFields[field] = value;
            } else {
              delete newChangedFields[field];
            }
          }

          // Lógica general para otros campos
          else {
            if (initialFormData1[field] !== value) {
              newChangedFields[field] = value;
            } else {
              delete newChangedFields[field]; // eliminar campo si vuelve a su valor inicial
            }
          }
          return newChangedFields;
        });

        return updatedFormData;
      });
    }

  };

  const handleButtonMessagePopUpErrorClick = () => {
    setShowPopupError(false);
    setShowModalError(true);
  };


  const handleSaveClick = useCallback(async () => {
    setLoading(true)

    if (validateAllFields()) {
      let newChangedFields = { ...changedFields };
      // Si changedFields.image tiene un valor, actualizar newChangedFields.image.
      if (changedFields.image) {
        newChangedFields.image = await getFileInformation(file);
      }

      // Lógica especial para comparar textos

      for (const key in initialFormData1) {
        // Verificar si la propiedad comienza con 'text', no es nula y su idioma no está en langTabs
        if (key.startsWith('text')) {

          if (!rteAreEqual(initialFormData1[key], formData1[key])) {
            newChangedFields[key] = formData1[key];
          } else {
            delete newChangedFields[key];
          }
        }
      }

      const apiResponse = await PatchCompanyService(newChangedFields, id);

      setApiData(apiResponse);
      if (typeof apiResponse !== "object") {
        setShowPopupError(true);
        setLoading(false)
      } else {
        setShowPopupContinue(true);
        setLoading(false)
      }
    }
    setLoading(false)

  });

  const handleCancelClick = async () => {
    navigate("/companies");
  };

  const handleEditorContentChange = (newContent, lang) => {
    const langUpperCase = lang.toUpperCase();
    const key = langUpperCase === 'ES' ? 'text' : 'text' + langUpperCase;

    setFormData1(prevFormData => ({
      ...prevFormData,
      [key]: {
        ...prevFormData[key],
        text: newContent
      }
    }));


  };


  const handleAddClicked = () => {
    setShowPopupWorkPlacesManage(true)
  };

  const handleEditClicked = (data) => {
    setWorkplaceData(data)
    setShowPopupWorkPlacesManage(true)
  };

  const handlePopUpWorkPlacesManageClose = () => {
    setShowPopupWorkPlacesManage(false)
    setWorkplaceData(null)
  }

  const handleAddCategoryResponsiblesClicked = () => {
    setShowPopupCategoryResponsiblesManage(true)
  };

  const handleEditCategoryResponsiblesClicked = (data) => {
    setCategoryResponsibleData(data)
    setShowPopupCategoryResponsiblesManage(true)
  };

  const handlePopUpCategoryResponsiblesManageClose = () => {
    setShowPopupCategoryResponsiblesManage(false)
    setCategoryResponsibleData(null)

    setCompanyCategoriesKey(prevKey => prevKey + 1);
  }


  const handleReloadData = async () => {
    setWorkplacesData(await getWorkPlaces(id))
  }

  const handleReloadCategoryResponsiblesData = async () => {
    setCategoryResponsiblesData(await getCategoryResponsibles(id))
  }

  const handleCloseDownloadResponsibles = () => {
    setShowDownloadResponsibles(false); // Cerrar el primer popup
    createdNewWorkplace && setShowCompanyCategoriesCreate(true); // Abrir el segundo popup
  };

  const handleCloseCompanyCategoriesCreate = () => {
    setShowCompanyCategoriesCreate(false);
    setCreatedNewWorkplace(false);
  };

  const handleButtonMessagePopUpWorkPlacesManage = async (idCompany, workPlaceName, workPlaceResponsible, changedResponsible) => {
    let result = null;

    const workPlaceData = {
      name: workPlaceName,
      company: companyData.companyId,
      responsibleId: workPlaceResponsible,
    }


    if (idCompany) {
      result = await PatchWorkPlaceService(workPlaceData, idCompany)
      setWorkplacesData(await getWorkPlaces(id))
      if (changedResponsible) {
        setShowDownloadResponsibles(true)
      }

    } else {
      result = await PostWorkPlaceService(workPlaceData)
      setWorkplacesData(await getWorkPlaces(id))
      if (changedResponsible) {
        setShowDownloadResponsibles(true)
      }
      setCreatedNewWorkplace(true)
    }

    if (result !== true) {
      setShowPopupErrorWorkPlaces(true)
    }
  }

  const handleButtonMessagePopUpCategoryResponsiblesManage = async (idCategoryReponsible, workplaceId, categoryId, responsibleId, categoryGroup, companyId, changedResponsible) => {
    let result = null;

    const categoryResponsiblesData = {
      company: companyId,
      incidentCategory: categoryId,
      categoryGroup: categoryGroup,
      workplace: workplaceId,
      responsible: responsibleId,
    }

    if (idCategoryReponsible) {
      result = await PatchCategoryResponsiblesService(categoryResponsiblesData, idCategoryReponsible)
      setCategoryResponsiblesData(await getCategoryResponsibles(id))
      if (changedResponsible && result) {
        setShowDownloadResponsibles(true)
      }

    } else {
      result = await PostCategoryResponsiblesService(categoryResponsiblesData)
      setCategoryResponsiblesData(await getCategoryResponsibles(id))
      if (changedResponsible && result) {
        setShowDownloadResponsibles(true)
      }
    }

    if (result !== true) {
      setShowPopupErrorWorkPlaces(true)
    }

  }

  const optionsNumber = (options) => {
    var cont = 0;
    options.forEach((option) => {
      if (option.value !== null && option.value !== "") {
        cont++;
      }
    });
    if (cont >= 1) {
      return false;
    }
    return true;
  };

  const isValidCIF = (cif) => {
    const regex = /^[A-Za-z][0-9]{7}[A-Za-z0-9]$/;
    return regex.test(cif);
  };

  const isValidNIF = (nif) => {
    const nifRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;
    if (!nifRegex.test(nif)) {
      return false;
    }

    const letters = "TRWAGMYFPDXBNJZSQVHLCKE";
    const number = parseInt(nif.slice(0, 8));
    const letter = nif.slice(8).toUpperCase();

    return letters[number % 23] === letter;
  };

  const isValidNIFCIF = (string) => isValidCIF(string) || isValidNIF(string);


  const handleAddSignFilesClicked = () => {
    setShowPopupSignFilesManage(true)
  };

  const handlePopUpSignFilesManageClose = () => {
    setShowPopupSignFilesManage(false)
  }

  const handleReloadSignFilesData = async () => {
    setSignFilesData(await getSignFile(id))
  }

  const handleReloadCategoriesData = async () => {
    setCategoriesData(await getCategories(id))
    setAllCategoriesData(await GetIncidentCategoriesService(id))
  }

  const handleReloadQuestionsData = async () => {
    setQuestionsData(await getQuestions(id))
  }


  /* WORKPLACES */
  async function getWorkPlaces(company) {
    const response = await GetWorkPlacesFromCompanyService(company);
    return response
  }

  /* SIGN FILES */
  async function getSignFile(company) {
    const response = await GetSignFilesService(company);
    return response
  }

  /* CUSTOM CATEGORIES */
  async function getCategories(company) {
    const response = await GetIncidentCategoriesNotDefaultService(company);
    return response
  }

  /* CUSTOM QUESTIONS */
  async function getQuestions(company) {
    const response = await GetCustomQuestionsService(company);
    return response
  }

  /* RESPONSIBLES */
  async function getCategoryResponsibles(company) {
    const response = await GetCategoryResponsiblesFromCompanyService(company);

    return response
  }

  useEffect(() => {
    async function fetchWorkPlacesData() {
      setWorkplacesData(await getWorkPlaces(id))
    }

    async function fetchSignFilesData() {
      setSignFilesData(await getSignFile(id))
    }

    async function fetchCategoriesData() {
      setCategoriesData(await getCategories(id))
    }

    async function fetchAllCategoriesData() {
      setAllCategoriesData(await GetIncidentCategoriesService(id))
    }

    async function fetchQuestionsData() {
      setQuestionsData(await getQuestions(id))
    }
    async function fetchCategoryResponsiblesData() {
      setCategoryResponsiblesData(await getCategoryResponsibles(id))
    }

    fetchWorkPlacesData();
    fetchSignFilesData();
    fetchCategoriesData();
    fetchAllCategoriesData();
    fetchQuestionsData();
    fetchCategoryResponsiblesData();
  }, []);


  useEffect(() => {
    if (categoryResponsiblesData) {
      // Extraer categorías únicas
      const uniqueCategories = [...new Set(categoryResponsiblesData.map(item => item.categoryName))];

      // Extraer sedes únicas, ignorando las que no tienen 'workplaceName'
      const uniqueWorkplaces = [...new Set(categoryResponsiblesData
        .filter(item => item.workplaceName)
        .map(item => item.workplaceName))];

      // Extraer nombres de responsables únicos
      const uniqueResponsibleNames = [...new Set(categoryResponsiblesData.map(item => item.responsibleFullNameNIF))];

      // Actualizar los estados
      setCategoryResponsiblesCategories(uniqueCategories);
      setCategoryResponsiblesWorkplaces(uniqueWorkplaces);
      setCategoryResponsiblesResponsibleNames(uniqueResponsibleNames);
    }
  }, [categoryResponsiblesData]);

  useEffect(() => {
    if (workplacesData) {
      const enabledWorkplaces = workplacesData
        .filter(workplace => workplace.workplaceEnabled)
        .map(workplace => ({
          label: workplace.workplaceName,
          value: workplace.workplaceId,
        }));
      setEnabledWorkplaces(enabledWorkplaces)
    }
  }, [workplacesData]);

  /* LANGUAGES RTE */

  const [showPopupRemoveCompanyText, setShowPopupRemoveCompanyText] = useState(false);
  const [removeCompanyTextId, setShowPopupRemoveCompanyTextId] = useState(null);
  const [defaultTab, setDefaultTab] = useState(false);

  const [langTabs, setLangTabs] = useState([])

  useEffect(() => {
    if (isLoaded && langTabs.length < 1) {
      const initialLangTabs = [
        {
          title: 'Español',
          language: 'es',
          content: (
            <div>
              <RTE
                rteContent={companyData.textCompanies.find(item => item.language === 'es').text}
                onContentChange={(val) => handleEditorContentChange(val, 'es')}
                key={changeData}
              />
            </div>
          )
        }
        // Puedes agregar más tabs aquí si es necesario
      ];
      setSpanishText(true);
      setLangTabs(initialLangTabs);
    }
  }, [isLoaded, companyData, changeData]); // Dependencias: isLoaded, companyData, changeData


  const addTab = async (tabLanguage) => {
    if (isLoaded) {
      //depende si se añade automáticamente (no tiene value) o por el botón de añadir 
      const languageCode = tabLanguage.value ? tabLanguage.value : tabLanguage;
      const textTranslated = companyData.textCompanies.find(item => item.language === languageCode);
      const langs = {
        'ca': 'Catalá',
        'eu': 'Euskara',
        'en': 'English',
        'it': 'Italiano'
      }
      const texts = {
        'ca': t("rte.welcomeTextCA"),
        'eu': t("rte.welcomeTextEU"),
        'en': t("rte.welcomeTextEN"),
        'it': t("rte.welcomeTextIT")
      }


      const id = {
        'ca': initialFormData1.textCA,
        'eu': initialFormData1.textEU,
        'en': initialFormData1.textEN,
        'it': initialFormData1.textIT
      }

      const newTab = {
        title: langs[tabLanguage.value ? tabLanguage.value : tabLanguage],
        language: tabLanguage.value ? tabLanguage.value : tabLanguage,
        id: id[tabLanguage.value ? tabLanguage.value : tabLanguage].textCompanyId,
        content: (
          <div>
            <RTE
              rteContent={textTranslated ? textTranslated.text : texts[tabLanguage.value]}
              onContentChange={(val) => handleEditorContentChange(val, textTranslated.language)}
              key={changeData}
            />
          </div>

        )
      };

      setLangTabs(prevTabs => {
        // Verificar si ya existe un tab con el mismo idioma
        const exists = prevTabs.some(tab => tab.language === newTab.language);
        if (!exists) {
          // Si no existe, añadir el nuevo tab
          return [...prevTabs, newTab];

        } else {
          // Si ya existe, simplemente devolver los tabs anteriores
          return prevTabs;
        }
      });
    }
    return true;
  };

  const handleDisableCompanyText = (id) => {
    setShowPopupRemoveCompanyText(true)
    setShowPopupRemoveCompanyTextId(id)

  }

  const handleButtonMessagePopUpRemoveCompanyClick = async () => {
    const response = await DisabledTextCompanyService(removeCompanyTextId);
    setShowPopupRemoveCompanyTextId(null);
    setShowPopupRemoveCompanyText(false);
    setChangeData((prevChangeData) => !prevChangeData); // Cambiar el estado para desencadenar el useEffect
    setIsLoaded(false);
    setSpanishText(false);
    setDefaultTab(!defaultTab);
    const updatedLangTabs = langTabs.filter((langTab) => langTab.id !== removeCompanyTextId);

    setLangTabs(updatedLangTabs);
    navigate(`/edit-company/${id}`);
  };

  const handleContinuePopUp = () => {
    setShowPopupContinue(false)
    let isKeyFound = false;

    const keysToFind = ['responsibleId', 'functionResponsibleId', 'responsibleManagementId'];

    if (changedFields) {
      isKeyFound = keysToFind.some(key => changedFields.hasOwnProperty(key));
    }
    if (isKeyFound) {
      setShowDownloadResponsibles(true)
    }
  }


  return (
    <div>
      <MessagePopUp
        show={showPopupError}
        handleClose={() => setShowPopupError(false)}
        title={apiData === "Error NIF" ? `${t("companiesPopup.nifErrorTitle")}` : `${t("companiesPopup.mailErrorTitle")}`}
        textBody={
          apiData === "Error NIF"
            ? `${t("companiesPopup.nifErrorText")}`
            : `${t("companiesPopup.mailErrorText")}`
        }
        buttonText={`${t("companiesPopup.acceptButton")}`}
        onClickButton={handleButtonMessagePopUpErrorClick}
      />
      <MessagePopUp
        show={showPopupContinue}
        handleClose={handleContinuePopUp}
        title={`${t("companiesPopup.companyModifiedSuccessText")}`}
        textBody={`${t("companiesPopup.companyModifiedSuccessTextMessage")}`}
        buttonText={`${t("companiesPopup.acceptButton")}`}
        onClickButton={handleContinuePopUp}
      />

      <MessagePopUp
        show={showCompanyCategoriesCreate}
        handleClose={handleCloseCompanyCategoriesCreate}
        title={`${t("companiesPopup.companyCategoriesCreateText")}`}
        textBody={`${t("companiesPopup.companyCategoriesCreateTextMessage")}`}
        buttonText={`${t("companiesPopup.acceptButton")}`}
        onClickButton={handleCloseCompanyCategoriesCreate}
      />

      <DownloadCertificationsPopUp
        show={showDownloadResponsibles}
        handleClose={handleCloseDownloadResponsibles}
        title={t("certificationsDownloadPopUp.popupDownloadResponsiblesTitle")}
        id={'responsibles'}
      />

      <MessagePopUp
        show={showPopupRemoveCompanyText}
        handleClose={() => setShowPopupRemoveCompanyText(false)}
        title={`${t("companiesPopup.companyTextRemoveTitle")}`}
        textBody={`${t("companiesPopup.companyTextRemoveMessage")}`}
        buttonText={`${t("companiesPopup.acceptButton")}`}
        cancelButtonText={`${t("companiesPopup.cancelButton")}`}
        onClickButton={handleButtonMessagePopUpRemoveCompanyClick}
        onClickCancelButton={() => setShowPopupRemoveCompanyText(false)}
      />

      <MessagePopUp
        show={showPopupErrorWorkPlaces}
        handleClose={() => setShowPopupErrorWorkPlaces(false)}
        title={`${t("companiesPopup.workplaceErrorText")}`}
        textBody={`${t("companiesPopup.workplaceErrorTextMessage")}`}
        buttonText={`${t("companiesPopup.acceptButton")}`}
        onClickButton={() => setShowPopupErrorWorkPlaces(false)}
      />

      <PopUpWorkPlacesManage
        show={showPopupWorkPlacesManage}
        handleClose={handlePopUpWorkPlacesManageClose}
        onClickButton={(id, workPlaceName, workPlaceResponsible, changedResponsible) => handleButtonMessagePopUpWorkPlacesManage(id, workPlaceName, workPlaceResponsible, changedResponsible)}
        responsibleOptions={responsibleOptionsFull}
        data={workplaceData}
        workPlacesData={workplacesData}
      />

      <PopUpCategoryResponsiblesManage
        customKey={companyCategoriesKey}
        show={showPopupCategoryResponsiblesManage}
        handleClose={handlePopUpCategoryResponsiblesManageClose}
        onClickButton={(id, workplaceId, categoryId, responsibleId, categoryGroup, companyId, changedResponsible) => handleButtonMessagePopUpCategoryResponsiblesManage(id, workplaceId, categoryId, responsibleId, categoryGroup, companyId, changedResponsible)}
        responsibleOptions={responsibleOptionsCategoryResponsibleFull}
        data={categoryResponsibleData}
        tableData={categoryResponsiblesData}
        workplacesOptions={enabledWorkplaces}
        categoriesOptions={allCategoriesData}
        companyId={companyData?.companyId}
      />

      <PopUpSignFilesManage
        key={showPopupSignFilesManage}
        show={showPopupSignFilesManage}
        handleClose={handlePopUpSignFilesManageClose}
        reloadData={handleReloadSignFilesData}
        company={companyData.companyId}
      />

      <Header
        manual={'https://www.myreportin.com/descargas/manual-de-usuario-Myreportin.pdf'}
        reloadData={() => { setChangeData(!changeData); handleReloadData(); handleReloadSignFilesData(); setReloadData(!reloadData); setIsLoaded(false); setSpanishText(false); }}
      />
      <Container fluid>
        <Row>
          <Col
            className='d-flex'
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              flex: `0 0 ${expanded ? "2%" : "4%"}`,
            }}
          >
            <Sidebar
              expanded={expanded}
              setExpanded={setExpanded}
              selected={"Empresas"}
            />
          </Col>
          <Col
            className='custom-content-wrapper'
            style={{
              marginLeft: `0.5%`,
              paddingRight: 0,
              flex: `0 0 ${expanded ? "86%" : "93%"}`,
            }}
          >
            <Row>
              <Col md={12}>
                <CommonCard title={t("editCompanyCard.title")} icon="FaBuilding">

                  <CustomTabs>
                    <CustomTab title={t("editCompanyCard.tabData")} icon='FaDatabase'>
                      <div>
                        <Row>
                          <Col md={6}>
                            <FormCard
                              title={t("companyForm.nif")}
                              text={companyData.nifCif}
                              type={"text"}
                              error={fieldErrors.nifCif}
                              errorMessage={fieldErrors.nifCifMessage}
                              readOnly={false}
                              onChange={(e) =>
                                handleInputChange(
                                  "nifCif",
                                  e.target.value,
                                  setFormData1
                                )
                              }
                            />
                          </Col>
                          <Col md={6}>
                            <FormCard
                              title={t("companyForm.name")}
                              text={companyData.name}
                              type={"text"}
                              error={fieldErrors.name}
                              errorMessage={fieldErrors.nameMessage}
                              readOnly={false}
                              onChange={(e) =>
                                handleInputChange(
                                  "name",
                                  e.target.value,
                                  setFormData1
                                )
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <FormCard
                              title={t("companyForm.responsible")}
                              type={"select"}
                              error={fieldErrors.responsible}
                              errorMessage={fieldErrors.responsibleMessage}
                              selectedValue={{
                                label: companyData.responsibleFullNameNIF,
                                value: companyData.responsibleId,
                              }}
                              options={responsibleOptions}
                              onChange={(e) =>
                                handleInputChange(
                                  "responsibleId",
                                  e.value,
                                  setFormData1
                                )
                              }
                            />
                          </Col>
                          <Col md={6}>
                            <FormCard
                              title={t("companyForm.functionsResponsible")}
                              type={"select"}
                              readOnly={optionsNumber(responsibleFunctionsOptions)}
                              options={responsibleFunctionsOptions}
                              selectedValue={{
                                label: companyData.functionResponsibleFullNameNIF,
                                value: companyData.functionResponsibleId,
                              }}
                              onChange={(e) =>
                                handleInputChange(
                                  "functionResponsibleId",
                                  e.value,
                                  setFormData1
                                )
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          {/* <Col md={6}>
                            <FormCard
                              title={t("companyForm.managementResponsible")}
                              type={"select"}
                              error={fieldErrors.responsibleManagement}
                              errorMessage={fieldErrors.responsibleManagementMessage}
                              options={responsibleManagementOptions}
                              selectedValue={{
                                label: companyData.managementResponsibleFullNameNIF,
                                value: companyData.managementResponsibleId,
                              }}
                              onChange={(e) =>
                                handleInputChange(
                                  "responsibleManagementId",
                                  e.value,
                                  setFormData1
                                )
                              }
                            />
                          </Col> */}
                          <Col md={5}>
                            <FormCard
                              title={t("companyForm.link")}
                              text={companyData.publicLink}
                              type={"href"}
                              readOnly={false}
                              copyClipBoard={true}
                              fontSmall
                            />
                          </Col>
                          <Col md={1}>
                            <FormCard

                              qrLink={companyData.publicLink}
                              type={"qr"}
                            />
                          </Col>
                        </Row>



                        <Row className="mt-4">
                          <Col md={8} >
                            <CustomTabs addTab langTabs={langTabs.length > 0 && langTabs} setNewTab={(language) => addTab(language)}
                              remove={handleDisableCompanyText}
                              setDefaultTab={defaultTab}
                            >

                              {langTabs.map((tab, index) => {

                                return (
                                  <CustomTab id={tab.id} key={index} title={tab.title} removable={tab.language !== 'es'}>
                                    {tab.content}
                                  </CustomTab>
                                );
                              })}
                            </CustomTabs>
                          </Col>
                          <Col md={4} className="margin-top-6">
                            {isLoaded &&
                              <FormCard
                                title={t("companyForm.image")}
                                type={"file"}
                                error={fieldErrors.image}
                                errorMessage={fieldErrors.imageMessage}
                                setFile={setFile}
                                defaultFile={true}
                                defaultImage={`data:${companyData.imageMimeType};base64,${companyData.imageData}`}
                                onChange={(e) => {
                                  handleInputChange("image", e, setFormData1);
                                }}
                              />
                            }
                          </Col>
                        </Row>


                        <div className="d-flex justify-content-around mt-4">
                          <Button
                            variant="secondary"
                            className="custom-button-secondary custom-shadow"
                            onClick={handleCancelClick}
                            disabled={loading}
                          >
                            {t("companyForm.cancelbutton")}
                          </Button>
                          <Button
                            variant="success"
                            className="custom-button-primary custom-shadow"
                            onClick={handleSaveClick}
                            disabled={!isForm1Valid || !formData1Changed || loading}
                          >
                            {loading ?
                              <>
                                <Spinner animation="border" className="spinner" />
                                <span className="common-card-card-text">{t("companyForm.savingbutton")}</span>

                              </>
                              :
                              <>
                                {t("companyForm.savebutton")}

                              </>
                            }
                          </Button>
                        </div>

                      </div>
                    </CustomTab>

                    <CustomTab title={t("editCompanyCard.tabWorkPlaces")} icon='FaCity'>
                      <div>
                        <Row>
                          <CustomTable
                            columnHeaders={columnHeaders}
                            fieldsToShow={fieldsToShow}
                            data={workplacesData}
                            optionArrays={optionArrays}
                            loading={loading}
                            dataType={'workPlaces'}
                            doubleButton
                            editButton
                            addButton
                            addClicked={handleAddClicked}
                            workPlacesTable
                            displayPopUp={handleEditClicked}
                            requiredReloadData={handleReloadData}
                          />
                        </Row>



                      </div>
                    </CustomTab>

                    <CustomTab title={t("editCompanyCard.tabCertifications")} icon='TbCertificate'>
                      <Row>
                        <Col md={7}>
                          <div className="clean-card-title"><FaDownload size={18} />{t("certificationsTab.certificationsTitle")}</div>
                        </Col>
                        <Col md={4}>
                          <div className="clean-card-title ms-5"><FaFileSignature size={18} />{t("certificationsTab.signatureTitle")}</div>
                        </Col>
                        <Col md={12} className="certifications-card-main-container">
                          <CertificationsCard base64QR={qrBase64} data={companyData} icon={'FaAddressCard'} title={t("certificationsTab.presentationCard")} id='presentation' />
                          <CertificationsCard icon={'TbFileCertificate'} title={t("certificationsTab.stamp")} id='stamp' />
                          <CertificationsCard icon={'FaQrcode'} title={t("certificationsTab.qr")} id='qr' qrLink={companyData.publicLink} openPopUp={false} />
                          <div class="vertical-separator" />
                          <CertificationsCard icon={'FaUserCheck'} title={t("certificationsTab.responsibleStartDocument")} id='responsibleStart' />
                          <CertificationsCard icon={'FaUserSlash'} title={t("certificationsTab.responsibleFinishDocument")} id='responsibleFinish' />
                        </Col>

                      </Row>
                      <Row className="mt-5 width-99 mx-auto">
                        <div className="clean-card-title"><FaRectangleList size={18} />{t("certificationsTab.signatureListTitle")}</div>

                        <Col md={12} className="">
                          <CustomTable
                            key={signFilesData}
                            columnHeaders={signFilesColumnHeaders}
                            fieldsToShow={signFilesFieldsToShow}
                            data={signFilesData}
                            optionArrays={[]}
                            loading={loading}
                            dataType={'signFiles'}
                            doubleButton
                            downloadButton
                            deleteButton
                            editButton={false}
                            addButton
                            addClicked={handleAddSignFilesClicked}
                            requiredReloadData={handleReloadSignFilesData}
                          />
                        </Col>

                      </Row>
                    </CustomTab>

                    <CustomTab title={t("editCompanyCard.tabIncidentCustomization")} icon='FaPalette'>
                      <div>
                        <Row>
                          <Col md={12}>
                            <div className="clean-card-title"><BiSolidCategoryAlt size={18} />{t("customIncidentTab.categoriesTitle")}</div>
                          </Col>
                          <Col md={12}>
                            <CustomizationCards
                              key={categoriesData}
                              company={companyData.companyId}
                              data={categoriesData}
                              reloadData={handleReloadCategoriesData}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <div className="clean-card-title"><FaCircleQuestion size={18} />{t("customIncidentTab.questionsTitle")}</div>
                          </Col>
                          <Col md={12}>
                            <CustomizationCards
                              key={questionsData}
                              company={companyData.companyId}
                              data={questionsData}
                              reloadData={handleReloadQuestionsData}
                              question
                            />
                          </Col>
                        </Row>


                      </div>
                    </CustomTab>

                    <CustomTab title={t("editCompanyCard.tabCategoryResponsibles")} icon='FaUserCheck'>
                      <div>
                        <Row>
                          <CustomTable
                            columnHeaders={categoryResponsiblesColumnHeaders}
                            fieldsToShow={categoryResponsiblesFieldsToShow}
                            data={categoryResponsiblesData}
                            key={categoryResponsiblesData}
                            optionArrays={categoryResponsiblesOptionArrays}
                            loading={loading}
                            dataType={'categoryResponsibles'}
                            doubleButton
                            editButton
                            addButton
                            deleteButton
                            addClicked={handleAddCategoryResponsiblesClicked}
                            categoryResponsiblesTable
                            displayPopUp={handleEditCategoryResponsiblesClicked}
                            requiredReloadData={handleReloadCategoryResponsiblesData}
                          />
                        </Row>





                      </div>
                    </CustomTab>

                  </CustomTabs>


                </CommonCard>





              </Col>
            </Row>

            <Footer />
          </Col>
        </Row>
      </Container >
    </div >
  );
};

export default EditCompany;
